module.exports = __webpack_public_path__ + "img/19034103295190235.32713499.jpg";